<template>
  <div class="home">
    <b-container class="page-container">
      <br>
      <b-row>
        <b-col>
          <div class="iframe-container-steam">
            <iframe src="https://store.steampowered.com/widget/1004090/?t=Exurgo%20is%20a%20rogue-lite%20shooter%20built%20for%20roomscale%20VR.%20Fight%20your%20way%20up%20an%20alien%20space%20elevator%20known%20as%20the%20Spire.%20Find%20secrets%2C%20collect%20power-ups%20and%20defeat%20bosses.%20Careful%2C%20each%20death%20will%20send%20you%20back%20to%20the%20start%2C%20but%20let%20you%20upgrade%20for%20your%20next%20ascent.%20Can%20you%20destroy%20the%20Spire%20and%20save%20the%20world%3F" frameborder="0"></iframe>
          </div>
          <!-- <home-carousel style="align: center"></home-carousel> -->
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <div class="iframe-container">
            <iframe src="https://www.youtube.com/embed/o9Ahoa4OBPA" frameborder="30" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <!-- <h3 align="left">A Sci-fi VR Roguelite</h3> -->
          <!-- <p class="text-justified">
            Earth has been betrayed by it’s alien benefactors. Their gift to humanity, a monolithic space elevator known as the Spire, was a trojan horse. Earth’s only hope is to use the alien’s weapons against them. Take control of an assault drone and fight to trigger the Spire’s self destruct. Starting planetside, navigate procedurally generated levels to climb your way into orbit. Standing in your way is an endless army of robots. Overcome them by collecting hundreds of unique mods to upgrade your equipment. Caution, one wrong move and your drone is destroyed, forcing you to start over with nothing. Use this opportunity to upgrade your drone and unlock powerful new abilities for your next ascent. Can you make it to the top and destroy the Spire once and for all?
          </p> -->
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col md="6">
          <h3>Latest Updates</h3>
          <h1 v-if="loading">
            <font-awesome-icon :icon="['fas', 'circle-notch']" class="fa-spin"/>
          </h1>
          <b-list-group class="listGroup" v-if="!loading">
            <b-list-group-item  v-for="entry in entries" :key="entry.entryId" class="flex-column align-items-start listGroup">
              <router-link :to="{ name: 'Entry', params: {entryId: entry.entryId } }" tag="div" style="cursor: pointer">
                <latest-entry :title="entry.title" :summary="entry.summary" :displayDate="entry.displayDate"></latest-entry>
              </router-link>
            </b-list-group-item>
          </b-list-group>
        </b-col>
        <b-col md="6">
          <h3>Latest Tweet</h3>
          <Timeline :id="'_FiniteGames'" :sourceType="'profile'" :options="{ tweetLimit: '1', theme: 'dark', chrome: 'transparent noheader nofooter' }"/>
        </b-col>
      </b-row>
      <b-row>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
        <br>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import HomeCarousel from '../components/HomeCarousel'
import LatestEntry from '../components/LatestEntry.vue'
import axios from 'axios'
import { Timeline } from 'vue-tweet-embed'

export default {
  name: 'home',
  data () {
    return {
      entries: [],
      loading: true
    }
  },
  components: {
    HomeCarousel,
    LatestEntry,
    Timeline
  },
  methods: {
    getLatestEntry: function () {
      axios.get('http://bargoapi.finitegames.com/api/finitegames/getLatestEntries/7')
        .then((response) => {
          this.entries = response.data.Entries
          this.loading = false
        }, (error) => {
          console.log(error)
          this.loading = false
        })
    }
  },
  beforeMount () {
    this.getLatestEntry()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .carousel {
        padding: 1em;
        max-width: 1000px !important;
        margin: auto !important;
    }
    .iframe-container {
      overflow: hidden;
      padding-top: 56.25%;
      position: relative;
    }
    .iframe-container iframe {
      border: 0;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
    .iframe-container-steam {
      overflow: hidden;
      padding-top: 18%;
      position: relative;
    }
    .iframe-container-steam iframe {
      border: 0;
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }
    @media (max-width: 1200px) {
      .iframe-container-steam {
        overflow: hidden;
        padding-top: 21%;
        position: relative;
      }
    }
    @media (max-width: 991px) {
      .iframe-container-steam {
        overflow: hidden;
        padding-top: 28%;
        position: relative;
      }
    }
    @media (max-width: 767px) {
      .iframe-container-steam {
        overflow: hidden;
        padding-top: 38%;
        position: relative;
      }
    }
    @media (max-width: 480px) {
      .iframe-container-steam {
        overflow: hidden;
        padding-top: 52%;
        position: relative;
      }
    }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue